import React, {Fragment, Component} from 'react';
import { Box } from '@mui/material';
import Button from '../components/Button/Button';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import {PageView} from "../model/enums/PageView";
import { AppLogo, AppLogoImg, DescriptionBox } from '../styles/jss/components/intro';
import { MainTitle, DescriptionTextBox, CenteredBox } from '../styles/jss/global';
import parse from "html-react-parser";
import { htmlParseOptions } from '../constants/htmlParseOptions';

class Welcome extends Component {

    classes: any;
    componentProps: any;
    componentEvents: any;

    constructor(props: any) {
        super(props);
        this.classes = props.classes;
        this.componentProps = {
            showHeader: false,
            app: {
                name: props.state.app.name,
                logo: props.state.app.logo,
                description: props.state.app.description,
                config: props.state.app.config
            }
        };

        this.componentEvents = {
            handleShowSpecificPage: props.handleShowSpecificPage
        };
    }

    handleShowFormPagesClick = () => {
        this.componentEvents.handleShowSpecificPage(PageView.FormPages);
    }

    render() {
        const introPageAppLogoMaxWidth = `${this.componentProps.app.config?.introPageAppLogoMaxWidth !== undefined ? 
            this.componentProps.app.config.introPageAppLogoMaxWidth : 75}%`;
       
        return (
            <Fragment>
                <Header {...this.componentProps} />

                <CenteredBox component="main" className='main' maxWidth="md">
                    <Box>
                        {this.componentProps.app.logo && introPageAppLogoMaxWidth !== '0%' &&
                            <AppLogo maxWidth={introPageAppLogoMaxWidth}>
                                <AppLogoImg src={this.componentProps.app.logo} alt="App logo" />
                            </AppLogo>
                        }
                        <DescriptionBox>
                            <MainTitle variant={'h3'} component={'h1'}>{this.componentProps.app.name}</MainTitle>
                            <DescriptionTextBox>{parse(this.componentProps.app.description, htmlParseOptions)}</DescriptionTextBox>
                        </DescriptionBox>
                        <Button
                            color="secondary"
                            variant="contained"
                            size="large"
                            disableElevation
                            onClick={this.handleShowFormPagesClick}
                        >Let's begin</Button>
                    </Box>
                </CenteredBox>

                <Footer />
            </Fragment>
        );
    }
}

export default Welcome
